import React, { JSX } from "react";
import { useSelector } from "react-redux";
import { Autocomplete, Box, Table, TableHead, TextField, Typography } from "@mui/material";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";

import { RootState } from "../../../store";
import EyeServicesRow from "./EyeServicesRow";
import { filterActiveLabService } from "../OtherServicesSelector";
import useAssessmentLabel from "../../../hooks/useAssessmentLabel";
import { ServiceInterface } from "../../../interfaces/ServiceInterface";
import { EyeService } from "../../../interfaces/AssessmentInterfaces";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

interface PropType {
  eyeServices: Array<EyeService>;
  handleAddService: (v: ServiceInterface) => void;
  handleUpdateService: (v: EyeService) => void;
  handleRemoveService: (i: Array<EyeService>) => void;
}

const EyeServices = ({
  eyeServices = [],
  handleAddService,
  handleUpdateService,
  handleRemoveService
}: PropType): JSX.Element => {
  const assessmentLabels = useAssessmentLabel();
  const services = useSelector((state: RootState) => state.services.collection) || [];
  const filteredServices = filterActiveLabService(services, []);

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel} sx={{ display: "flex", alignItems: "center" }}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.eyeServices}
        </Typography>
      </Box>

      <Box className={styles.assessmentField}>
        <>
          <Box display="flex" alignItems="center" width="100%">
            <Autocomplete
              fullWidth
              options={filteredServices}
              value={[]}
              getOptionLabel={(option) => option.name || ""}
              renderOption={(params, option) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <li {...params} key={option.id}>
                  {`${option.name || ""} ${option.subType ? ` (${option.subType})` : ""}`}
                </li>
              )}
              onChange={(_, v) => {
                if (v) {
                  handleAddService(v);
                }
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label={assessmentLabels.eyeServices}
                  slotProps={{
                    inputLabel: { shrink: true }
                  }}
                  placeholder="Search and select services"
                  variant="outlined"
                  margin="dense"
                />
              )}
            />
          </Box>

          {eyeServices.length > 0 && (
            <Box sx={{ mt: "16px" }}>
              <TableContainer>
                <Table sx={{ minWidth: 650 }} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>SN.</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell sx={{ width: "250px" }}>Note</TableCell>
                      <TableCell sx={{ textAlign: "right", width: "50px" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {eyeServices?.map((item, i) => (
                      <EyeServicesRow
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${item.name}-${i}`}
                        item={item}
                        index={i}
                        services={eyeServices}
                        handleUpdateService={handleUpdateService}
                        handleRemoveService={handleRemoveService}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </>
      </Box>
    </Box>
  );
};

export default EyeServices;
